import dayjs from 'dayjs';

import { getUserRole } from 'utils/CodeMapper';
import { getDisplayName } from 'utils/getDisplayName';
import { sortByDate, sortByText } from 'utils/tableSorters';

export const USER_TABLE_SCROLL_X = 1400;

export const formatUserCustomerName = (record) => record?.customer?.name || '-';

export const formatUserEmail = (value) => value || '-';

export const buildUserColumns = () => [
  {
    title: '아이디',
    key: 'id',
    dataIndex: 'id',
    width: 160,
    ellipsis: true,
    sorter: sortByText((record) => record.id),
  },
  {
    title: '성명',
    key: 'name',
    width: 140,
    dataIndex: 'name',
    ellipsis: true,
    sorter: sortByText((record) => record.name),
  },
  {
    title: '역할',
    key: 'role',
    dataIndex: 'role',
    width: 120,
    align: 'center',
    sorter: sortByText((record) => getUserRole(record.role)),
    render: (_, record) => getUserRole(record.role),
  },
  {
    title: '고객사',
    key: 'customer',
    dataIndex: 'customer',
    width: 180,
    ellipsis: true,
    sorter: sortByText((record) => formatUserCustomerName(record)),
    render: (_, record) => formatUserCustomerName(record),
  },
  {
    title: '이메일',
    key: 'email',
    dataIndex: 'email',
    width: 260,
    ellipsis: true,
    sorter: sortByText((record) => formatUserEmail(record.email)),
    render: (value) => formatUserEmail(value),
  },
  {
    title: '등록일시',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.createdAt),
    render: (_, record) => dayjs(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '등록자',
    key: 'createdBy',
    dataIndex: 'createdBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.createdBy)),
    render: (_, record) => getDisplayName(record.createdBy),
  },
  {
    title: '수정일시',
    key: 'updatedAt',
    dataIndex: 'updatedAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.updatedAt),
    render: (_, record) => dayjs(record.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '수정자',
    key: 'updatedBy',
    dataIndex: 'updatedBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.updatedBy)),
    render: (_, record) => getDisplayName(record.updatedBy),
  },
];
